import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':employeeId'}/setToUnavailable`;

export const ROUTE: RouteDefinition = `${baseRoute}/:employeeId/setToUnavailable`;

export const URL = (employeeId: number): RouteDefinition => `${baseRoute}/${employeeId}/setToUnavailable`;
